import { number } from "prop-types";
import React from "react";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Card, CardTitle, CardBody, CardText } from "reactstrap";
import { authenticationService } from "services/authentication.service";
import Card_Descargas, { function_obtener_regimen_segun_id } from "./Card_Descargas";
import Card_Egresos_Mensuales from "./Card_Egresos_Mensuales";
import Card_Ingresos_Anuales from "./Card_Ingresos_Anuales";
import Card_Ingresos_Mensuales from "./Card_Ingresos_Mensuales";
import { Dashboard_Admin_Type, Data_Dashboard_Ingresos, Data_Dashboard_Vacaciones, titulos_dashboard } from "./Dashboard_Admin";



export interface IPropsDashboardIndividual {
    datos: any,
    status_response?: number
}

export const formatoFecha = (date: string | undefined): string => {
    if (date) {
        const fecha = date.split("T")[0];
        const hora = date.split("T")[1].split(".")[0];

        const fechaSeparada = fecha.split("-");
        const year = fechaSeparada[0];
        const month = fechaSeparada[1];
        const day = fechaSeparada[2];
        return day + "/" + month + "/" + year;
    }
    else { return "" }


};



export const function_capitalize = (input: string) => {
    return input.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
}



export const parseo_mes: Array<string> = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']


const URL_TALENTO_HUMANO_VACACIONES = "https://talentohumano.espol.edu.ec/Sitio/IO/Personal/Vacaciones.aspx";


const Dashboard_IndividualAdmin: React.FC<Dashboard_Admin_Type> = (props: Dashboard_Admin_Type) => {
    const history = useHistory();

    //VACACIONES


    const function_redirigir_vacaciones = () => {
        var win = window.open(URL_TALENTO_HUMANO_VACACIONES, '_blank');
        win?.focus();
    }

    const redirigir_planificacion = () => {
        history.push("/web/planificacion_vacaciones")
    }

    const function_transformar_mes = (fecha: string): string => {
        var fecha_string = fecha.split(" ")[0];
        var indice_mes: number = +fecha_string.split("/")[1] - 1
        return parseo_mes[indice_mes];
    }

    const function_texto_meses_vacaciones_tomadas = (key_meses: string, value: number, value_year: number): string => {
        var key_dividido: Array<string> | undefined = key_meses.split("-");
        if (key_dividido.length > 1) {
            var indice_primer_mes: number = +key_dividido[0] - 1;
            var indice_segundo_mes: number = +key_dividido[1] - 1;

            return "Usted tomó " + value + " día(s) ordinario(s) de vacaciones entre los meses de " + parseo_mes[indice_primer_mes] + " y " + parseo_mes[indice_segundo_mes] + "-" + value_year;
        }
        var indice: number = + key_meses - 1;
        return `Usted tomó ${value} día(s) ordinario(s) de vacaciones en el mes de ${parseo_mes[indice]}-${value_year}`;

    }

    const card_body_vacaciones = (): JSX.Element => {
        const ESTADO_SOLICITUD_PENDIENTE = "PEN";
        var datos_dashboard: Data_Dashboard_Vacaciones = props.datos ? props.datos : null;
        var mensaje_estado_vacaciones: string = ""
        var mensaje_meses_planificados: string = ""
        var restriccion_loes = false;
        var currentUser = authenticationService.currentUserValue;
        var regimen_usuario = currentUser.regimen_usuario;


        if (regimen_usuario.length == 1 && function_obtener_regimen_segun_id(regimen_usuario[0]) === "CIVIL")
            restriccion_loes = true

        if (datos_dashboard) {
            var fecha_fin_vacaciones_string = datos_dashboard.fecha_fin_vacaciones?.toString();
            if (datos_dashboard.isinVacation) { mensaje_estado_vacaciones = "Usted se encuentra en vacaciones hasta el " + formatoFecha(fecha_fin_vacaciones_string) + "\n" }
            else if (datos_dashboard.estado_solicitud_vacaciones === ESTADO_SOLICITUD_PENDIENTE) { mensaje_estado_vacaciones = "Usted tiene una solicitud pendiente de aprobar\n" }

            // if (datos_dashboard.meses_vacaciones_planificado && datos_dashboard.meses_vacaciones_planificado.length != 0) {
            //     mensaje_meses_planificados = "Usted tiene planificado tomar vacaciones en los meses de "
            //     datos_dashboard.meses_vacaciones_planificado.map((fechas, index) => {
            //         var indice_mes: number = +fechas - 1
            //         var mes_string = parseo_mes[indice_mes]
            //         if (index + 1 != datos_dashboard.meses_vacaciones_planificado?.length) {
            //             mensaje_meses_planificados = mensaje_meses_planificados + " " + mes_string + " Y "
            //         } else {
            //             mensaje_meses_planificados = mensaje_meses_planificados + " " + mes_string
            //         }
            //     })
            // }

        }

        var code_status: number | undefined = props.status_response;

        if (code_status && code_status === 500) {
            return (
                <CardBody>
                    <div>Ha ocurrido un error al tratar de obtener información </div>
                </CardBody>
            )
        } else if (code_status && code_status === 0) {
            return (
                <CardBody>
                    <div>No fue posible contactarse con el servidor </div>
                </CardBody>
            )
        }



        if (datos_dashboard === null) {
            return (<CardBody>
                <div>No hay información de vacaciones disponible</div>
            </CardBody>)
        }


        return (
            <CardBody>

                {datos_dashboard &&
                    <div className="font-weight-bold">
                        {`Días ordinarios de vacaciones pendientes: ${datos_dashboard.cantidad_vacaciones_pendientes}`}
                    </div>
                }
                {datos_dashboard.dias_planificados !== 0 &&
                    <div className="mt-3">Ud. ha planificado {datos_dashboard.dias_planificados} día(s) ordinario(s) para el año {datos_dashboard.anio_vacaciones_recientes}</div>
                }
                {
                    <div className="mt-3" >Ud. ha tomado {datos_dashboard.dias_tomados} día(s) ordinario(s) en el año {datos_dashboard.anio_vacaciones_recientes}.
                    <Link to ="/web/solicitud_vacaciones">
                        Para hacer una solicitud de vacaciones haga click aquí
                    </Link>
                    
                    </div>
                }
                {/* <div>{datos_dashboard ? mensaje_meses_planificados : ""}</div> */}
                {/* <div className="text-right mb-1">{props.datos && <button onClick={() => function_redirigir_vacaciones()}>Solicitar vacaciones</button>}</div> */}
                <div className="mt-3">{datos_dashboard ? mensaje_estado_vacaciones : ""}</div>
                {datos_dashboard.periodo_planificacion_activo && datos_dashboard.tiene_planificacion_sgteanio  && datos_dashboard.anioPeriodoPlanificacion > 0 &&
                    <div className="mensaje_planifca_aqui_dash">{`Nos encontramos en el período de planificación de vacaciones del año ${datos_dashboard.anioPeriodoPlanificacion}. `}

                        {datos_dashboard.cantidadMinimaFaltaPlanificar > 0 && datos_dashboard.tiene_planificaciones_rechazadas_sgteanio?
                            <div className="mensaje_planifca_aqui_dash">
                                {"Tiene planificaciones rechazadas. Faltan por planificar " + datos_dashboard.cantidadMinimaFaltaPlanificar + " día(s) ordinario(s)"}
                            </div>
                            : ""}




                        <a className="click_planificar_vacaciones_dashboard" onClick={() => redirigir_planificacion()}>Planifique aquí</a>
                    </div>
                }

                {/* <div>{datos_dashboard.vacaciones_recientes?.map((vac_re, index) => {
                    if (index <= 1) {
                        return (
                            <React.Fragment key={"vacaciones_tomadas " + index} >
                                <p>{function_texto_meses_vacaciones_tomadas(vac_re.Key, vac_re.Value, datos_dashboard.anio_vacaciones_recientes)}</p>
                            </React.Fragment>
                        )
                    }

                })}</div> */}
            </CardBody>
        )
    }



    const function_escoger_card_body = (): JSX.Element => {
        switch (props.titulo) {
            case titulos_dashboard[0]:
                return <Card_Ingresos_Mensuales datos={props.datos} status_response={props.status_response} />;

            case titulos_dashboard[1]:
                return <Card_Egresos_Mensuales datos={props.datos} status_response={props.status_response} />

            case titulos_dashboard[2]:
                return <Card_Ingresos_Anuales datos={props.datos} status_response={props.status_response} />

            case titulos_dashboard[3]:
                return card_body_vacaciones();

            case titulos_dashboard[4]:
                return <Card_Descargas datos={props.datos} status_response={props.status_response} />;
            default:
                return <div>{props.contenido}</div>;
        }
    }


    return (
        <React.Fragment>
            <Card className="card_dashboard_admin">

                <CardTitle className="container_card_header_admin">
                    {props.no_circle ? <img className="image_nocircle_header" src={props.icon ? props.icon : ""}></img>
                        :
                        <div className="circle_header" style={{ background: `${props.color}` }} >
                            <img className="image_circle_header" src={props.icon ? props.icon : ""}>
                            </img>
                        </div>}
                    {/* <div className="circle_header" style={{ background: `${props.color}` }} >
                        <img className="image_circle_header" src={props.icon ? props.icon : ""}>

                        </img>
                    </div> */}

                    <div className="container_text_card_header_admin">
                        <span>
                            {props.titulo}
                        </span>
                    </div>


                </CardTitle>

                {function_escoger_card_body()}

            </Card>
        </React.Fragment>
    )
}
export default Dashboard_IndividualAdmin;